define([
  'immutable',
  'underscore',
  'es6!sumo/util',
  'es6!sumo/list/actions/Constants',
], (Immutable, _, Util, Constants) => {
  const initialState = Immutable.Map({
    byObjectId: Immutable.Map(),
    byService: Immutable.Map(),
    state: Immutable.List(),
    order: Immutable.List(),
    reqId: null,
    hash: null,
    enterprise: false,
    filter: '',
  });

  const actionHandlers = {};

  actionHandlers[Constants.UPDATE_INTEGRATION_FILTER] = (state, action) => {
    return state.set('filter', action.filter);
  };

  actionHandlers[Constants.SAVE_SERVICE_SETTINGS] = (state, action) => {
    return state.mergeIn(['byObjectId', action.objectId, action.service], Immutable.fromJS({ saving: true }));
  };

  actionHandlers[Constants.REQUEST_SERVICE_SETTINGS] = (state, action) => {
    return state.mergeIn(['byObjectId', action.objectId, action.service], Immutable.fromJS({ loading: true }));
  };

  actionHandlers[Constants.RECEIVE_SERVICE_SETTINGS] = (state, action) => {
    const settings = _.omit(action.settings, 'success');

    return state.setIn(['byObjectId', action.objectId, action.service], Immutable.fromJS(settings));
  };

  actionHandlers[Constants.UPDATE_INTEGRATION_SETTING] = (state, action) => {
    const { setting, value } = action;
    return state.set(setting, value);
  };

  actionHandlers[Constants.UPDATE_SERVICE_SETTINGS] = (state, action) => {
    const settings = _.omit(action.settings, 'success');

    return state.setIn(['byObjectId', action.objectId, action.service], Immutable.fromJS(settings));
  };

  actionHandlers[Constants.REMOVE_SERVICE_SETTINGS] = (state, action) => {
    if (action.service) {
      if(action.objectId === 'events') {
        // Remove "loading" and "saving" from state.
        const serviceState = state.getIn(['byObjectId', action.objectId, action.service]).toJS();
        const cleanState = _.omit(serviceState, ['loading', 'saving']);

        return state.setIn(['byObjectId', action.objectId, action.service], Immutable.fromJS(cleanState));
      }

      return state.deleteIn(['byObjectId', action.objectId, action.service]);
    } else {
      return state.deleteIn(['byObjectId', action.objectId]);
    }
  };

  actionHandlers[Constants.ERROR_SERVICE_SETTINGS] = (state, action) => {
    if (action.service) {
      return state.setIn(['byObjectId', action.objectId, action.service], Immutable.fromJS({ error: action.error }));
    } else {
      return state.setIn(['byObjectId', action.objectId], Immutable.fromJS({ error: action.error }));
    }
  };

  actionHandlers[Constants.RECEIVE_FORMSYNC_SETTINGS] = (state, action) => {
    const settings = _.omit(action.settings, 'success');

    return state.mergeIn(['byService', 'formsync', action.objectId], Immutable.fromJS(settings));
  };

  actionHandlers[Constants.REQUEST_CONNECT] = (state, action) => {
    return state.mergeIn(['byService', action.service], Immutable.fromJS({ connecting: true }));
  };

  actionHandlers[Constants.ERROR_CONNECT] = (state, action) => {
    return state.setIn(['byService', action.service], Immutable.fromJS({ errors: _.omit(action.error, 'success') }));
  };

  actionHandlers[Constants.ERROR_SERVICE_CONFIG] = (state, action) => {
    return state.setIn(['byService', action.service], Immutable.fromJS({ error: action.error }));
  };

  actionHandlers[Constants.DISCONNECT_SERVICE] = (state, action) => {
    const services = state.get('state');

    return state.setIn(['state'], services.filter(service => service !== action.service));
  };

  actionHandlers[Constants.RECEIVE_SERVICE_STATE] = (state, action) => {
    const {
      req_id: reqId,
      hash,
      enterprise,
      order,
      sumoApiKey,
      services,
      hasApiCohort,
    } = action;

    return state.merge({
      reqId,
      hash,
      enterprise,
      order,
      sumoApiKey,
      hasApiCohort,
      state: Immutable.List(_.keys(services)),
    });
  };

  actionHandlers[Constants.RECEIVE_EXACTTARGET_FIELDS] = (state, action) => {
    const extensions = (state.getIn(['byService', 'exacttarget', 'extensions']) || Immutable.List()).toJS();

    if (extensions) {
      const extension = _.find(extensions, ((extension) => extension.id === action.extensionId));

      if (extension) {
        _.extend(extension, action.config);

        return state.setIn(['byService', 'exacttarget', 'extensions'], Immutable.fromJS(extensions));
      }
    }

    return state;
  };

  actionHandlers[Constants.REQUEST_SERVICE_CONFIG] = (state, action) => {
    return state.deleteIn(['byService', action.service]);
  };

  actionHandlers[Constants.RECEIVE_SERVICE_CONFIG] = (state, action) => {
    return state.setIn(['byService', action.service], Immutable.fromJS(_.omit(action.config, 'success')));
  };

  actionHandlers[Constants.RECEIVE_ADDITIONAL_SERVICE_CONFIG] = (state, action) => {
    const lists = (state.getIn(['byService', action.service, 'lists']) || Immutable.List()).toJS();

    if (lists) {
      const list = _.find(lists, ((list) => list.id === action.listId));

      if (list) {
        _.extend(list, _.omit(action.config, 'success'));

        return state.setIn(['byService', action.service, 'lists'], Immutable.fromJS(lists));
      }
    }

    return state;
  };

  return Util.createReducer(initialState, actionHandlers);
});
